export const sk5Data = {
    name: 'sk5',
    baseUrl: "/samples/drums/sk5/",
    // parts: ["kick1", "kick2", "snare1", "snare2", "hihat1", "hihat2", "conga1", "conga2"],
    parts: ["kick", "snare", "hihat", "ohihat", "conga1", "conga2"],
    samples: {
        C4: "kick1.wav",
        D4: "snare1.wav",
        E4: "hihat2.wav",
        F4: "hihat1.wav",
        G4: "conga1.wav",
        A4: "conga2.wav"
        // C4: "kick1.wav",
        // D4: "kick2.wav",
        // E4: "snare1.wav",
        // F4: "snare2.wav",
        // G4: "hihat1.wav",
        // A4: "hihat2.wav",
        // B5: "conga1.wav",
        // C5: "conga2.wav"
    }
}